const LV_BREAKPOINT = 1024;
const MV_BREAKPOINT = 768;
const SV_BREAKPOINT = 0;

export const isLV = ({ width }) => width >= LV_BREAKPOINT;
export const isMV = ({ width }) => width >= MV_BREAKPOINT && width < LV_BREAKPOINT;
export const isSV = ({ width }) => width >= SV_BREAKPOINT && width < MV_BREAKPOINT;
